import { Capacitor } from '@capacitor/core'
import { Badge } from '@capawesome/capacitor-badge'
import { apolloClient } from '@/vendor/apollo-client.ts'
import { BACKGROUND_OPERATION } from '@/utils/backgroundOperation'
import { GET_UNREAD_NOTIFICATIONS_COUNT } from '@/queries/notifications.ts'
import { useInfoStore } from '@/stores/info.ts'

// Badge failures are non-critical (plugin may be unimplemented on a given build /
// platform, e.g. before `npx cap sync`). Swallow them so they never reach Sentry.
async function badgeIsSupported(): Promise<boolean> {
  if (!Capacitor.isNativePlatform()) {
    return false
  }
  try {
    return (await Badge.isSupported()).isSupported
  } catch {
    return false
  }
}

export async function clearAppBadge(): Promise<void> {
  if (!(await badgeIsSupported())) {
    return
  }
  try {
    await Badge.clear()
  } catch (error) {
    console.warn('clearAppBadge failed', error)
  }
}

export async function syncAppBadgeFromUnreadCount(): Promise<void> {
  // Unread count is a server query; it can't resolve while we're not connected
  // (offline, forced offline, or server down). Skip.
  if (!useInfoStore().connected) {
    return
  }
  if (!(await badgeIsSupported())) {
    return
  }
  try {
    const { data } = await apolloClient.query({
      query: GET_UNREAD_NOTIFICATIONS_COUNT,
      fetchPolicy: 'network-only',
      context: BACKGROUND_OPERATION,
    })
    const unreadCount = data?.notificationsCount ?? 0
    if (unreadCount > 0) {
      await Badge.set({ count: unreadCount })
    } else {
      await Badge.clear()
    }
  } catch (error) {
    console.warn('syncAppBadgeFromUnreadCount failed', error)
  }
}
